const indexData = [
  { title: '热血漫', desc: '燃到停不下来', count: '3,200+部', icon: 'ri-fire-line', bg: 'bg-primary-50', text: 'text-primary-600' },
  { title: '恋爱漫', desc: '甜到心坎里的故事', count: '2,800+部', icon: 'ri-heart-line', bg: 'bg-accent-50', text: 'text-accent-600' },
  { title: '悬疑漫', desc: '烧脑推理不间断', count: '1,500+部', icon: 'ri-search-eye-line', bg: 'bg-secondary-50', text: 'text-secondary-600' },
  { title: '奇幻漫', desc: '打开异世界大门', count: '2,100+部', icon: 'ri-magic-line', bg: 'bg-primary-50', text: 'text-primary-600' },
  { title: '搞笑漫', desc: '每日一笑乐开怀', count: '1,800+部', icon: 'ri-emotion-laugh-line', bg: 'bg-accent-50', text: 'text-accent-600' },
  { title: '科幻漫', desc: '未来世界任遨游', count: '980+部', icon: 'ri-rocket-line', bg: 'bg-secondary-50', text: 'text-secondary-600' },
  { title: '恐怖漫', desc: '惊悚刺激够胆来', count: '760+部', icon: 'ri-ghost-line', bg: 'bg-primary-50', text: 'text-primary-600' },
  { title: '日常漫', desc: '温暖治愈每一天', count: '1,200+部', icon: 'ri-sun-line', bg: 'bg-accent-50', text: 'text-accent-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            漫画索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按品类快速定位你喜欢的连载漫画，发现更多追漫佳作
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className={`${item.bg} rounded-xl p-5 flex flex-col items-center text-center hover:scale-[1.02] transition-transform cursor-pointer`}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-2xl ${item.text}`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-800 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-semibold text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}